var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTransdyne01({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 150,
    height: 20,
    viewBox: "0 0 150 20",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3689_13491)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.4889 0.228516H3.93798C1.88498 0.228516 0.220703 1.85581 0.220703 3.86318V16.1352C0.220703 18.1426 1.88498 19.7699 3.93798 19.7699H16.4889C18.5419 19.7699 20.2062 18.1426 20.2062 16.1352V3.86318C20.2062 1.85581 18.5419 0.228516 16.4889 0.228516Z",
    fill: "url(#paint0_linear_3689_13491)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.75732 7.05268L15.2319 3.52734L17.8746 4.738L17.4437 9.63134L13.2355 7.42067L15.1255 7.31667L16.5819 7.99934L16.8491 5.31667L15.2864 4.63401L10.9691 6.94867L8.75732 7.05268Z",
    fill: "#1A91CD"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.1035 7.26367L18.469 10.9463L18.739 13.7357L14.2062 15.893L13.9908 11.2103L15.0708 12.789L15.1771 14.3143L17.7135 13.2103L17.5526 11.5783L13.2899 9.05301L12.1035 7.26367Z",
    fill: "#1A91CD"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.6145 10.1582L13.5599 17.4195L11.1872 19.0515L6.979 16.3155L11.0781 13.7902L10.2163 15.4729L8.86628 16.3155L11.1872 17.8942L12.5345 16.9449L12.589 12.1049L13.6145 10.1582Z",
    fill: "#1A91CD"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.779 12.8939L5.35904 16.5259L2.71631 15.3685L3.04085 10.4219L7.30085 12.5792L5.41358 12.7365L3.95722 12.0512L3.74176 14.7872L5.25267 15.4192L9.56722 13.0512L11.779 12.8939Z",
    fill: "#1A91CD"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.43546 12.7895L2.01546 9.15749L1.69092 6.37083L6.22365 4.16016L6.49365 8.84282L5.3591 7.31749L5.25274 5.73882L2.71637 6.89615L2.93183 8.52816L7.19455 10.9468L8.43546 12.7895Z",
    fill: "#1A91CD"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.86998 9.84255L6.81543 2.63455L9.13634 0.949219L13.3991 3.63455L9.35179 6.21322L10.1618 4.52789L11.5091 3.63455L9.19088 2.10922L7.84088 3.10922V7.94922L6.86998 9.84255Z",
    fill: "#1A91CD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.53 6.11516H30.2373V16.6938H27.7255V6.11516H23.4546V4.3125H34.5246L34.53 6.11516Z",
    fill: "#333367"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.3545 16.6927H45.2236L39.0736 11.9514C38.9617 11.8553 38.8749 11.7346 38.8203 11.5992C38.7658 11.4637 38.7451 11.3175 38.7599 11.1727C38.7599 10.4829 39.2772 10.138 40.3118 10.138L43.9854 10.1114C45.2072 10.1114 45.8154 9.70071 45.8154 8.87671V7.46604C45.8154 6.60204 45.1254 6.17004 43.7454 6.17004H38.5636V16.6927H36.0518V4.35938H44.4845C47.0499 4.35938 48.3336 5.23582 48.3354 6.9887V9.12204C48.3415 9.48768 48.2532 9.84891 48.0787 10.1724C47.9043 10.4958 47.6492 10.7711 47.3372 10.9727C46.6718 11.442 45.7963 11.6767 44.7108 11.6767H41.8199L48.3545 16.6927Z",
    fill: "#333367"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.5135 16.6927H61.8245L60.3217 13.666H53.5035L52.0008 16.6927H49.3145L54.919 5.47137C55.2981 4.73004 55.9608 4.35938 56.9126 4.35938C57.8644 4.35938 58.5299 4.73004 58.909 5.47137L64.5135 16.6927ZM59.5254 11.9754L56.7981 6.48204L54.3108 11.9754H59.5254Z",
    fill: "#1A91CD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.8327 6.14961H85.3936C84.3409 6.14961 83.6836 6.34161 83.4245 6.71761C83.2718 6.9505 83.1954 7.47317 83.1954 8.28561C83.1915 8.48953 83.2448 8.6906 83.3496 8.86692C83.4545 9.04324 83.6068 9.18806 83.79 9.28561C84.1172 9.47406 84.6518 9.56917 85.3936 9.57095H88.0581C89.1927 9.57095 90.1018 9.79317 90.7854 10.2376C91.1068 10.4351 91.37 10.7112 91.5488 11.0385C91.7277 11.3659 91.8162 11.7333 91.8054 12.1043V14.0563C91.8214 14.4425 91.733 14.8261 91.5491 15.1683C91.3653 15.5105 91.0925 15.7993 90.7581 16.0056C90.06 16.4589 89.1045 16.6856 87.8918 16.6856H80.7109V14.8829H87.1472C88.2163 14.8829 88.8818 14.6767 89.1436 14.2643C89.26 14.0509 89.3181 13.4954 89.3181 12.5976C89.3181 11.7603 88.62 11.3407 87.2236 11.3389H84.559C83.6143 11.3762 82.6768 11.1633 81.8454 10.7229C81.0709 10.2696 80.6836 9.65628 80.6836 8.86961V6.94428C80.6836 6.08028 81.1045 5.39316 81.9463 4.88294C82.5354 4.52739 83.39 4.34961 84.51 4.34961H91.8327V6.14961Z",
    fill: "#333367"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.286 13.8666C107.3 14.2603 107.22 14.6518 107.052 15.0098C106.884 15.3678 106.632 15.6822 106.317 15.9279C105.674 16.4364 104.755 16.6915 103.56 16.6933H94.7974V4.33594H103.508C106.026 4.33594 107.286 5.25771 107.286 7.10127V13.8666ZM104.809 13.2719V7.5946C104.809 6.60794 104.119 6.1146 102.739 6.1146H97.3119V14.9013H102.739C104.119 14.9013 104.809 14.3582 104.809 13.2719Z",
    fill: "#333367"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.495 4.34961L116.703 11.6696V16.6936H114.202V11.6696L108.434 4.34961H111.297L115.388 9.70694L119.632 4.34961H122.495Z",
    fill: "#333367"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.055 15.1995C136.061 15.4181 136.017 15.6352 135.928 15.8356C135.838 16.036 135.705 16.2148 135.537 16.3595C135.125 16.6739 134.623 16.855 134.1 16.8774C133.578 16.8999 133.061 16.7627 132.622 16.4849C132.332 16.1804 132.077 15.845 131.864 15.4849L126.019 6.78085V16.7062H123.619V6.14885C123.619 4.94885 124.301 4.34885 125.665 4.34885C126.167 4.3151 126.666 4.44959 127.08 4.73018C127.383 5.02991 127.646 5.36591 127.863 5.73018L133.656 14.4208V4.45818H136.055V15.1995Z",
    fill: "#333367"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.6247 4.45898V14.4216L69.832 5.73098C69.6391 5.42281 69.4211 5.13031 69.1802 4.85632V8.56565L73.8329 15.499C74.0448 15.8601 74.2993 16.1957 74.5911 16.499C75.0296 16.7779 75.5462 16.9161 76.0689 16.8941C76.5916 16.8721 77.0942 16.6911 77.5065 16.3763C77.6742 16.2316 77.8075 16.0528 77.897 15.8524C77.9865 15.652 78.0301 15.4349 78.0247 15.2163V4.45898H75.6247Z",
    fill: "#333367"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.9884 6.90161V4.36561C67.8766 4.36561 67.7593 4.34961 67.6338 4.34961C66.2702 4.34961 65.5884 4.94961 65.5884 6.14961V8.86961L67.9884 6.90161Z",
    fill: "#1A91CD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.5884 10.05V16.7167H67.9884V9.95137V8.08203L65.5884 10.05Z",
    fill: "#1A91CD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.101 11.2296H141.101V13.315C141.101 14.2376 141.828 14.699 143.283 14.699H149.774V16.499H142.601C141.366 16.499 140.403 16.2892 139.71 15.8697C139.356 15.6689 139.063 15.3783 138.864 15.0287C138.664 14.6791 138.564 14.2833 138.575 13.883V6.93365C138.56 6.54192 138.645 6.15266 138.821 5.80047C138.997 5.44829 139.259 5.14411 139.585 4.91498C140.257 4.42432 141.187 4.17987 142.375 4.18165H149.774V5.98165H143.264C141.809 5.98165 141.082 6.43499 141.082 7.34165V9.45099H147.9L147.101 11.2296Z",
    fill: "#333367"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3689_13491",
    x1: 12.6189,
    y1: 8.03119,
    x2: 28.8654,
    y2: -5.89098,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#323366"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1C90CC"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3689_13491"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 150,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTransdyne01);
export default __webpack_public_path__ + "static/media/transdyne-01.f9632e1b5d4feaeca9409d69f60e0850.svg";
export { ForwardRef as ReactComponent };